"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FedopsLoggerService = void 0;
const static_service_1 = require("@wix/static-service");
const definitions_1 = require("../definitions");
const fedopsLogger_1 = require("../fedopsLogger");
exports.FedopsLoggerService = (0, static_service_1.implementStaticService)(definitions_1.FedopsLoggerDefinition, (_config) => {
    return (0, fedopsLogger_1.createFedopsLogger)();
});
//# sourceMappingURL=fedopsLoggerService.js.map